import Button from '@mui/material/Button'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import {useNavigate} from 'react-router-dom'

export default function PlayButton(props: { deckId: number, playType: 'normal' | 'reversed', text: string }) {
  const navigate = useNavigate()
  const playUrl = `/play/${props.deckId}${props.playType === 'reversed' ? '?reversed=true' : ''}`

  return (
    <Button
      onClick={_ => navigate(playUrl)}
      startIcon={<PlayArrowIcon/>}
      variant="contained"
      fullWidth
      color="success"
      sx={{
        mt: 2,
        mr: 2,
        fontSize: '18px',
        fontWeight: 900,
        textTransform: 'none',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {props.text}
    </Button>
  )
} 
